import axios from 'axios';
import {AuthModel, UserModel, BranchModel} from './_models';

const API_URL = process.env.REACT_APP_API_URL;
const API_LOGIN = process.env.REACT_APP_API;

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/api/personal/profile`;
export const GET_LIST_BRANCH = `${API_URL}/api/v1/branchusers/search`;

export const GET_PERMISSIONS_BY_URL = `${API_URL}/api/personal/permissions`;
export const LOGIN_URL = `${API_URL}/api/tokens`;
export const REGISTER_URL = `${API_URL}/api/tenants`;
export const REQUEST_PASSWORD_URL = `${API_URL}/api/users/forgot-password`;
export const RESET_PASSWORD_URL = `${API_URL}/api/users/reset-password`;
// Server should return AuthModel
var tenant = '';
var hostname = window.location.hostname;
if (hostname?.includes('localhost') || hostname?.includes('192.168.2.136')  || hostname?.includes('quanly'))  {
  tenant = 'root';
} else {
  var arr = hostname.split('.');
  tenant = arr[0];
}
export function login(userName: string, password: string) {
  return axios.post<AuthModel>(
    `${API_URL}/api/tokens`,
    {
      userName,
      password,
    },
    {headers: {tenant: "root", 'Content-Type': 'application/json', Accept: 'application/json'}}
  );
}
// Server should return AuthModel
export function register(
  id: string,
  name: string,
  adminEmail: string,
  userName: string,
  password: string,
  phoneNumber: string,
  employeeId: string,
) {
  return axios
    .post(REGISTER_URL, {
      adminEmail,
      name,
      id,
      userName,
      password,
      phoneNumber,
      address: '',
      connectionString: '',
      issuer: '',
      employeeId
    })
    .catch((error) => {
      return error?.response ?? null;
    });
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  var myHeaders = new Headers();
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('tenant', 'root');
  var raw = JSON.stringify({"email":email});
 return   fetch(`${API_LOGIN}/api/users/forgot-password`, {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  })
  .then((response) => response.status)
  .catch((res) => console.log(res ))
}
export function resetPassword(code: string, newPassword: string,email: string) {
  var myHeaders = new Headers();
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('tenant', 'root');
  var raw = JSON.stringify({"token":code,"password":newPassword,"email":email});
 return  fetch(  `${API_LOGIN}/api/users/reset-password`, {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  })
  .then((response) => response)
  .catch((res) => console.log(res ))
}

export function getUserByToken(token: string) {
  return axios.get<UserModel>(`${API_URL}/api/personal/profile`);
}

export function getBranchByToken(token: string) {
  return axios.post<Array<BranchModel>>(
    GET_LIST_BRANCH,
    {},
    {
      headers: {
        tenant: 'root',
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
